<app-dialog-title [title]="data.title" [state]="data.state"></app-dialog-title>
<p>{{ data.message }}</p>
<div class="row">
	<span class="spacer"></span
	><button mat-flat-button class="btn-focus" mat-dialog-close>
		<mat-icon iconPositionEnd>close</mat-icon>
		{{ 'ROOT.STRINGS.CLOSE' | translate }}
	</button>
</div>
